import * as React from "react";
import { ReservesFilterControl } from "./ReservesFilterControl";
import { useWindowLocation } from "./WindowLocation";
export interface ReservesResultsFilterProps {}
export const ReservesResultsFilter: React.FC<ReservesResultsFilterProps> = (
  props
) => {
  const { hashParamsMap, replaceHashParam } = useWindowLocation();

  // hashParamsMap may be updating too frequently
  const getReservesParam = React.useCallback((param: string) => {
    if (!hashParamsMap) return null;
    const section = hashParamsMap.get("section");
    const db = hashParamsMap.get("db");
    if (section === "search" && db === "reserves") {
      return hashParamsMap.get(param) || null;
    }
    return null;
  }, [hashParamsMap]);

  const instructor = React.useMemo(() => getReservesParam("instructor"), [hashParamsMap]);
  const course = React.useMemo(() => getReservesParam("course"), [hashParamsMap]);
  const department = React.useMemo(() => getReservesParam("department"), [hashParamsMap]);

  return (
    <ReservesFilterControl
      instructor={instructor}
      course={course}
      department={department}
      onChangeCourse={(newCourse) => {
        replaceHashParam("course", newCourse);
      }}
      onChangeDepartment={(newDepartment) => {
        replaceHashParam("department", newDepartment);
      }}
      onChangeInstructor={(newInstructor) => {
        replaceHashParam("instructor", newInstructor);
      }}
    ></ReservesFilterControl>
  );
};
